type CustomerReference = Record<string, any> | null | undefined

export function resolveQuenticCustomerId(customer: CustomerReference) {
  return customer?.customerId ?? customer?.id ?? customer?.id_kunde
}

export function quenticTokenRotationPath(customer: CustomerReference) {
  const id = resolveQuenticCustomerId(customer)
  if (id === null || id === undefined) return null

  return `/kunde/${id}/rotate_quentic_token`
}
